var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-icon-button',{staticClass:"nav-item",class:{active: _vm.isActive},attrs:{"icon":_vm.icon,"iconSize":_vm.iconSize,"appearance":"nav","type":"bp"},on:{"click":_vm.onNavigate}})}
var staticRenderFns = []

export { render, staticRenderFns }